import React from 'react';
import {Alert, Button} from "antd";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {InfoCircleOutlined} from "@ant-design/icons";

function LmsLevelIdNeedStudentSection(props) {


    return (

        <div>

            <Alert
                className={'flex flex-wrap'}
                rootClassName={'flex flex-wrap'}
                showIcon={true}
                icon={<InfoCircleOutlined/>}
                message="سلام"
                type="info"
                description={
                    <>

                        برای دسترسی به این مرحله فرایند ثبت نام به عنوان دانش آموز را در سیستم تکمیل کنید
                        <div className={'m-2'}>
                            <Link to={URLS.gateway.selector}>
                                <Button size="small" type="primary">
                                    تکمیل پروفایل
                                </Button>
                            </Link>


                        </div>

                    </>}
            />


        </div>
    );
}

export default LmsLevelIdNeedStudentSection;